import React from 'react';
import { Link } from 'react-router-dom';

const Nav = () => {
    return (
        <div className="fixed-top loginTopBG">
            <div className="container d-flex justify-content-between align-items-center">
                <div className="logo">
                    <Link to="/">
                        <img
                            src="images/logo.png"
                            className="img-fluid"
                            alt="logo-img"
                        />
                    </Link>
                </div>
                <div className="accountBtn">
                    <Link to="/login" className="btn loginBtn">LOGIN</Link>
                    <Link to="/" className="btn regBtn">REGISTER</Link>
                </div>
            </div>
        </div>
    );
}

export default Nav;
